import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useMutation } from "react-query";

import {
  CheckboxLabel,
  CheckboxRow,
  Container,
  Content,
  ErrorText,
  FooterText,
  FooterWrapper,
  Input,
  Label,
  StrongLink,
  SubmitButton,
  Title,
} from "./styles";
import { useAxiosPrivate } from "hooks/api/useAxiosPrivate";
import { useAuth } from "context/AuthContext";

interface LoginForm {
  username: string;
  password: string;
}

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState<LoginForm>({
    username: "",
    password: "",
  });

  const { auth, storeAuth } = useAuth();
  const axiosPrivate = useAxiosPrivate();

  const { mutate, isLoading, error } = useMutation(
    () => {
      return axiosPrivate.post("/dashboard/login", form);
    },
    {
      onSuccess: (data) => {
        const { token, user } = data.data;
        storeAuth(token, user);
        navigate("/dashboard");
      },
      onError: (error) => {
        const err: any = error;
        console.error("Login error:", err);
      },
    }
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    mutate();
  };

  if (auth.token) {
    navigate("/dashboard");
  }

  return (
    <Container>
      <Content>
        <Title>Login</Title>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "1rem" }}>
            <Label htmlFor="email">Email Address:</Label>
            <Input
              id="username"
              name="username"
              value={form.username}
              onChange={handleChange}
              placeholder="Username or Email"
              required
            />
          </div>
          <div style={{ marginBottom: "1rem" }}>
            <Label htmlFor="password">Password:</Label>
            <Input
              id="password"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Password"
              required
            />
          </div>
          <CheckboxRow>
            <CheckboxLabel>
              <input type="checkbox" name="remember" onChange={handleChange} />
              Remember me
            </CheckboxLabel>
          </CheckboxRow>
          <SubmitButton type="submit" disabled={isLoading}>
            {isLoading ? "Logging in..." : "Login / Sign in"}
          </SubmitButton>
          {Boolean(error) && <ErrorText>Invalid credentials</ErrorText>}
          <FooterText>
            Don't have an account?{" "}
            <StrongLink to="https://acfautomation.com/signup">
              Sign Up
            </StrongLink>
          </FooterText>
        </form>
      </Content>
      <FooterWrapper>
        © {new Date().getFullYear()} ACF Automation. All rights reserved.
      </FooterWrapper>
    </Container>
  );
};

export default LoginPage;
